/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');
var Marionette = require('backbone.marionette');
var Ladda = require('ladda');
var Radio = require('backbone.radio');

var HeaderBarView = require('common/views/HeaderBarView');

var SubmitCompliance = require('../services/SubmitCompliance');
var SecComplianceBreadcrumbView = require('./SecComplianceBreadcrumbView');
var SecComplianceGeneralInfoFormView = require('./SecComplianceGeneralInfoFormView');

var tmplSecComplianceGeneralInfoEditView = require('../templates/SecComplianceGeneralInfoEditView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplSecComplianceGeneralInfoEditView,

  className: 'sec-compliance-general-info-edit-view container-fluid',

  ui: {
    headerBar: '.header-bar',
    breadcrumb: '.breadcrumb-container',
    complianceGeneralInfoForm: '.compliance-general-info-form-container',
    submit: '.btn-submit'
  },

  regions: {
    headerBar: '@ui.headerBar',
    breadcrumb: '@ui.breadcrumb',
    complianceGeneralInfoForm: '@ui.complianceGeneralInfoForm'
  },

  events: {
    'click @ui.submit': 'onClickSubmit'
  },

  onBeforeShow: function() {
    var compliance = this.model.get('compliance') || {};
    var identifiers = compliance.identifiers || {};
    var complianceId = this.model.get('complianceId');
    var actionType = compliance.actionType;

    var objectId = compliance.objectId;

    var headerData = {
      title: 'Compliance',
      dbaName: identifiers.dbaName,
      crdNumber: identifiers.crdNumber,
      licenseType: identifiers.licenseType,
      examCaseNumber: identifiers.examCaseNumber,
      actionType: identifiers.actionType
    };

    this.showChildView(
      'headerBar',
      new HeaderBarView({
        columns: new Backbone.Collection([
          {
            name: 'crdNumber',
            label: 'CRD Number',
            minWidth: '160px'
          },
          {
            name: 'licenseType',
            label: 'License Type',
            minWidth: '160px'
          },
          {
            name: 'examCaseNumber',
            label: 'Exam/Case Number',
            minWidth: '160px'
          },
          {
            name: 'actionType',
            label: 'Action Type',
            minWidth: '160px'
          }
        ]),
        model: new Backbone.Model(headerData)
      })
    );

    this.showChildView(
      'breadcrumb',
      new SecComplianceBreadcrumbView({
        identifiers: identifiers,
        objectId: objectId,
        breadcrumbs: [
          {
            text: actionType + ' Compliance Case',
            link: '#sec/compliance/' + complianceId + '/dashboard'
          },
          {
            text: 'Edit General Information'
          }
        ]
      })
    );

    this.complianceGeneralInfoForm = new SecComplianceGeneralInfoFormView({
      model: this.model
    });

    this.showChildView('complianceGeneralInfoForm', this.complianceGeneralInfoForm);
  },

  onClickSubmit: function(e) {
    e.preventDefault();
    this.validate().done(
      function() {
        var laddaContext = Ladda.create(this.ui.submit.get(0));
        laddaContext.start();
        var formData = this.getFormData();
        SubmitCompliance(formData)
          .done(function() {
            Radio.channel('navigate').trigger('show:int:sc:compliance', formData.complianceId);
          })
          .fail(function() {
            laddaContext.stop();
          });
      }.bind(this)
    );
  },

  validate: function() {
    return this.ui.complianceGeneralInfoForm.parsley().whenValidate();
  },

  getFormData: function() {
    return this.complianceGeneralInfoForm.getFormData();
  }
});
